<div class="card-view-container aza-pa-grid aza-pa-two-columns-grid-full-width-columns aza-pa-flex-item-align-normal">
  @for (iconData of localData; track iconData) {
    <div class="card-container aza-pa-padding mat-elevation-z2">
      <div class="card-title aza-pa-flex-row aza-pa-content-space-between">
        <h2 class="aza-pa-primary-color">{{iconData.name}}</h2>
        <button action="select-card-menu-{{ iconData.id }}" (click)="onCardMenuSelected(iconData)" mat-icon-button
          [matMenuTriggerFor]="actionsMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <div class="card-content aza-pa-flex-row">
        <div class="card-thumbnail">
          <img [src]="iconData.thumbnailSrc" class="thumbnail-image aza-pa-full-width" />
        </div>
      </div>
    </div>
  }
  <mat-menu #actionsMenu="matMenu">
    @for (action of actions; track action) {
      <button action="select-card-action-{{ action.id }}" [disabled]="getActionMenuItemDisabledState(action)"
        (click)="onCardMenuActionSelected(action)" mat-menu-item>
        <mat-icon color="primary">{{action.icon}}</mat-icon>
        <span>{{action.label}}</span>
      </button>
    }
  </mat-menu>
</div>
